import React from 'react';
import PropTypes from 'prop-types';
import '../../css/Cards/CardTextChronique.css';
import ChevronRight from '../../svg/ICON_chevronRight_Dark.svg';
import Image from '../ImageElement';
import {List} from 'immutable';
import Modal from '../../Modal';
import ImageModal from './ImageModal';
/**
 * CardTextChronique component
 */
class CardTextChronique extends React.Component {
  static displayName = 'CardTextChronique';
  static propTypes = {
    className: PropTypes.string,
    sections: PropTypes.object,
    title: PropTypes.string,
    children: PropTypes.node,
    screen: PropTypes.string,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = 'CardTextChronique';
    this.popper = null;
    this.chroniqueSections = null;
    this.button = null;
    this.card = null;
    this.state = {
      openCat: -1,
      maxHeightLine: new List(),
      imageModal: null,
    };
    this.displayModal = this.displayModal.bind(this);
    this.toggleCat = this.toggleCat.bind(this);
    this.calculateHeight = this.calculateHeight.bind(this);
  }

  /**
   * Display / Hide products pan
   * @param  {Number} ID Category ID
   */
  toggleCat(ID) {
    if (this.state.openCat === ID) {
      this.setState({openCat: -1});
      setTimeout(() => {
        this.card.style['marginBottom'] = null;
      }, 100);
    } else {
      this.setState({openCat: ID});
      setTimeout(() => {
        this.card.style['marginBottom'] =
          this.chroniqueSections.offsetHeight + 'px';
      }, 100);
    }
  }
  /**
   * Display given image in a modal
   * @param {string} imageURL
   */
  displayModal(imageURL) {
    this.setState({imageModal: imageURL});
  }

  /**
   * @override
   */
  componentWillReceiveProps(nextProps) {
    if (nextProps.screen === 'mobile') {
      console.log('RESET MinHeight');
    }
  }

  /**
   * A new reference is inserted in the dom, set the height.
   *
   * @param {DOMELement} ref
   * @param {Number} height
   */
  calculateHeight(ref, index) {
    return parseInt(window.getComputedStyle(ref).height, 10);
  }

  /**
   * @override
   */
  render() {
    // console.log('render state is ', this.state.maxHeightLine.toJS());
    return (
      <div
        className={`${this.className} ${this.props.className || ''}`}
        ref={(ref) => (this.card = ref)}
      >
        {this.state.imageModal && (
          <Modal>
            <ImageModal
              src={this.state.imageModal}
              onClose={() => {
                this.setState({imageModal: null});
              }}
            />
          </Modal>
        )}
        <div className={`${this.className}__intro`}>
          <div
            className={`${this.className}__title`}
            dangerouslySetInnerHTML={{__html: this.props.currentPage.Title}}
          />
          <div className={`${this.className}__text`}>
            <div
              dangerouslySetInnerHTML={{
                __html: this.props.currentPage.Content,
              }}
            />
          </div>
        </div>

        {this.props.sections.map((section) => {
          const content = (
            <div dangerouslySetInnerHTML={{__html: section.Content}} />
          );
          const images = section.chroniques().map((chronique) => {
            return (
              <div
                className={`${this.className}__imgs ${this.className}__imgs--${
                  chronique.images().size
                }`}
                key={chronique.ID}
              >
                {chronique.images().map((image) => {
                  return (
                    <Image
                      className={
                        'clickable ' + image.isLandscape
                          ? 'landscape'
                          : 'portrait'
                      }
                      key={image.ID}
                      src={image[`${this.props.screen}_src`]}
                      alt={image.alt}
                      onClick={() => {
                        if (
                          this.state.openCat === -1 ||
                          this.state.openCat === section.ID
                        ) {
                          this.setState({
                            imageModal: image[`${this.props.screen}_src`],
                          });
                        } else {
                          this.setState({openCat: section.ID});
                        }
                      }}
                    />
                  );
                })}
              </div>
            );
          });
          return (
            <div
              className={`${this.className}__category ${
                this.state.openCat === section.ID
                  ? 'open'
                  : this.state.openCat !== -1
                  ? 'close'
                  : ''
              }`}
              key={section.ID}
            >
              <div className={`${this.className}__image`}>
                <Image
                  alt={section.cardMedia().alt}
                  src={section.cardMedia().desktop_src}
                  className="clickable"
                  onClick={() => {
                    if (
                      this.state.openCat === -1 ||
                      this.state.openCat === section.ID
                    ) {
                      this.setState({
                        imageModal: section.cardMedia().desktop_src,
                      });
                    } else {
                      this.setState({openCat: section.ID});
                    }
                  }}
                />
              </div>
              <div
                className="title"
                dangerouslySetInnerHTML={{__html: section.Title}}
              />

              {(section.Content || section.chroniques().size > 0) && (
                <div className="products__container">
                  <div
                    className="btn"
                    onClick={() => this.toggleCat(section.ID)}
                    ref={(ref) => (this.button = ref)}
                  >
                    <a>
                      En savoir plus
                      <img src={ChevronRight} className="icon" alt=">" />
                    </a>
                  </div>
                  <div
                    className={
                      'products' +
                      (this.state.openCat === section.ID ? ' open' : '')
                    }
                    ref={(prod) => (this.chroniqueSections = prod)}
                  >
                    <div className="products__left">{content}</div>
                    <div className="products__right">{images}</div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

export default CardTextChronique;



// WEBPACK FOOTER //
// ./src/components/Cards/CardTextChronique.js